import React from 'react'
import classes from '../Navbar.module.scss'

export class NavbarBreadcrumbItem extends React.Component {
  render () {
    const {
      children,
      icon,
      href,
      className,
      onClick,
      ...restProps
    } = this.props

    const Tag = href ? 'a' : 'span'

    let compClassName = classes.navbarBreadcrumbItem
    if (!icon) compClassName += ' ' + classes.withoutIcon
    if (onClick) compClassName += ' ' + classes.clickable
    if (className) compClassName += ' ' + className
    if (href) compClassName += ' clear-link-style'

    return (
      <Tag
        {...restProps}
        href={href}
        className={compClassName}
        onClick={onClick}
      >
        {icon &&
          <span className={classes.navbarBreadcrumbItemIcon}>
            {icon}
          </span>
        }
        {children &&
          <span className={classes.navbarBreadcrumbItemName}>
            {children}
          </span>
        }
      </Tag>
    )
  }
}

export default NavbarBreadcrumbItem
